<template>
    <div class="popup-wrap">
        <div
            class="popup-modal"
            :class="{ '-dark': dark }"
            @click="close"
        ></div>
        <div class="popup-content" :class="{ '-wide': wide, '-dark': dark }">
            <div class="popup-content-header" v-if="header">
                <div class="popup-header-title">{{ $t(title) }}</div>
                <i v-if="!blockClose" class="material-icons" @click="close"
                    >close</i
                >
            </div>
            <div class="popup-slot" ref="content">
                <slot></slot>
            </div>
            <div class="popup-actions" v-if="actions && actions.length > 0">
                <ActionButton
                    :color="action.color"
                    @click="emitAction(action)"
                    :label="$t(action.display)"
                    :materialIcon="action.icon"
                    :loading="action.loading"
                    v-for="(action, index) in actions"
                    :key="index"
                />
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        header: {
            type: Boolean,
            default: true
        },
        title: String,
        actions: Array,
        wide: Boolean,
        blockClose: Boolean,
        dark: Boolean
    },
    methods: {
        scrollTop() {
            this.$nextTick(() => {
                this.$refs.content.scrollTop = this.$refs.content.scrollHeight
            })
        },
        emitAction(payload) {
            if (payload.action.name) {
                this.$emit('action', payload.action)
            } else {
                this.$emit(payload.action)
            }
        },
        close() {
            if (this.blockClose) {
                return
            }
            this.$emit('close')
        }
    },
    mounted() {
        window.addEventListener('keyup', event => {
            if (event.keyCode === 27) {
                this.close()
            }
        })
    }
}
</script>
<style lang="scss" scoped>
.popup-wrap {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: $highest;
    transition: $ease;

    &.-hidden {
        pointer-events: none;
    }
}
.popup-content {
    padding: 0rem;
    overflow-y: visible;
    position: relative;
    box-sizing: border-box;
    background: var(--background);
    border-radius: $small-radius;
    width: 50%;
    min-width: 200px;
    max-height: 85%;
    margin: 58px 0;
    z-index: $highest;
    display: flex;
    flex-direction: column;
    color: var(--color);
    i {
        color: var(--color);
    }
    &.-wide {
        width: 80%;
    }
    &.-list {
        width: 80%;
    }

    &.-small {
        width: 40%;
    }
    @media (max-width: 1000px) {
        width: 95%;
    }
}
.popup-modal {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    z-index: $high;
    cursor: pointer;
    background: #535353bb;
    transition: all 0.5s ease;
}
.popup-content-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem;
    border-bottom: $list-border;
    font-size: 1.5rem;
    font-family: $input-family;

    i {
        margin-left: auto;
        transition: $ease;
        cursor: pointer;
        color: $input;

        &:hover {
            transform: translateY(0.1rem);
        }
    }
}
.popup-slot {
    max-height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 1rem;
    scroll-behavior: smooth;
}
.popup-actions {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 1rem;
    border-top: $list-border;
}
</style>
